export enum ECheckStatus {
  pending = "pending",
  "pre-processed" = "pre-processed",
  processed = "processed",
  processing = "processing",
  voided = "voided",
  failed = "failed",
}
